<ng-container *transloco="let t">
  <div class="branch-selector">
    <label class="ui-label ui-label--required">{{ t('branchSelector.label') }}</label>

    @if (branchOptions().length === 0) {
      <input type="hidden" name="branchSelector" [ngModel]="null" required />
    }

    @if (loading()) {
      <pxw-alert type="neutral" size="sm" display="inline" role="status" aria-live="polite">
        <pxw-icon icon="loading" [spin]="true" />
        {{ t('branchSelector.loading') }}
      </pxw-alert>
    } @else if (error()) {
      <div class="branch-selector__error" role="alert">
        <span>{{ error() }}</span>
      </div>
    } @else if (branchOptions().length > 0) {
      <div class="branch-selector__list">
        @for (branch of visibleBranches(); track branch.id) {
          <label
            class="branch-card"
            [class.branch-card--selected]="selectedBranchIdInternal() === branch.id"
            [class.branch-card--closest]="branch.isClosest"
          >
            <input
              type="radio"
              name="branchSelector"
              [value]="branch.id"
              [ngModel]="selectedBranchIdInternal()"
              (ngModelChange)="onBranchSelected($event)"
              required
            />
            <div class="branch-card__content">
              <div class="branch-card__main">
                <div class="branch-card__header">
                  <strong class="branch-card__name">{{ branch.name }}</strong>
                  @if (branch.isClosest) {
                    <span class="branch-card__badge">{{ t('branchSelector.closest') }}</span>
                  }
                </div>
                <div class="branch-card__details">
                  <span class="branch-card__address">{{ formatAddress(branch.address) }}</span>
                  @if (branch.schedule) {
                    <span class="branch-card__separator">·</span>
                    <span class="branch-card__schedule">{{ branch.schedule }}</span>
                  }
                </div>
              </div>
              @if (branch.distanceKm !== null) {
                <div class="branch-card__distance">{{ branch.distanceKm }} km</div>
              }
            </div>
          </label>
        }
      </div>

      @if (hasMoreBranches()) {
        <button type="button" class="branch-selector__toggle" (click)="toggleShowAll()">
          @if (showAllBranches()) {
            {{ t('branchSelector.showLess') }}
          } @else {
            {{ t('branchSelector.showMore', { count: hiddenBranchesCount() }) }}
          }
        </button>
      }

      @if (isFormSubmitted() && !selectedBranchIdInternal()) {
        <div class="branch-selector__validation-error">
          {{ t('branchSelector.required') }}
        </div>
      }
    } @else {
      <div class="branch-selector__empty">
        <pxw-icon icon="store"></pxw-icon>
        <span>{{ t('branchSelector.noAgencies') }}</span>
      </div>
    }
  </div>
</ng-container>
